<template>
    <div v-if="!isReset">
        <h4 class="mb-2">Change Password 🔒</h4>
        <p class="mb-4">Enter your new password</p>
        <form class="mb-3"  @submit.prevent="reset">
            <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input v-model="password" type="password" placeholder="New password" class="form-control" required />
            </div>
            
            <button class="btn btn-info d-grid w-100"  type="submit">Reset Password</button>
            <p>{{ message }}</p>
        </form>
    </div>

    <div v-else>
        <h4 class="mb-2">Change Password 🔒</h4>
        <p class="mb-4">Password has been changed</p>
    </div>
    
    <div class="text-center">
        <a href="/login" class="d-flex align-items-center justify-content-center">
            <i class="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
            Back to login
        </a>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                password: '',
                message: '',
                isReset: false
            };
        },
        mounted() {
            this.token = this.$route.params.token;
        },
        methods: {
            async reset() {
                try {
                    const res = await axios.post('/auth/reset-password', {
                        token: this.token,
                        password: this.password
                    });
                    this.isReset = true
                    this.message = res.data;
                } catch (err) {
                    this.message = err.response?.data || 'Reset failed';
                }
            }
            }
    };
</script>
